/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { Transition } from 'react-transition-group'
import { Modal } from '@entrata/portals-common/lib/components'
import { X, Phone } from '@entrata/portals-common/lib/icons'
import { connect } from 'react-redux'
import { showLinks } from 'constants/common';
import styled from '@emotion/styled'
import { LIGHT_GRAY, WHITE } from 'constants/theme'


const duration = 350

const StyledDiv = styled('div')`
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.secondary.base};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  opacity: 0;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: opacity ${duration}ms ease-out;
  z-index: 10;

  &.entered {
    opacity: 1;
  }
`

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.secondary.medium};
  display: ${({ showLink }) => (showLink ? 'block' : 'none')};
  font-family: ${({ theme }) => theme.fonts.soehneBuch};
  font-size: 36px;
  height: auto;
  position: relative;
  text-align: center;
  transition: color 200ms ease-out;

  &:hover,
  &:focus {
    color: white;
    outline: none;
  }

  &:not(:last-of-type):after {
    width: 200px;
    height: 1px;
    content: '';
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    display: block;
    padding: 0;
    margin: 32px 0;
  }
`

const StyledButton = styled('button')`
  background: transparent;
  border: none;
  color: white;
  padding: 0;
  position: absolute;
  top: 24px;
  right: 16px;
  z-index: 2;
`

//to override setGlobalStyles a[href=':tel'] we used important
const StyledPhoneButton = styled(StyledLink)`
  color: ${LIGHT_GRAY} !important;  
  width: ${({ block }) => (block ? '100%' : 'auto')};
  height: 48px;
  border: solid 1px ${({ theme }) => theme.gray.medium};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.fonts.soehneBuch};
  font-size: 14px;
  padding: 0 24px;
  user-select: none;
  border-radius: 24px;
  background: transparent;
  svg{
    margin-right: 5px;
  }
`
const StyledSpan = styled('span')`
  display: inline-block;
  color: ${LIGHT_GRAY};
  margin-bottom: 8px;
`

const MarketingNavModal = ({ emailAddress, onClose, show }) => {
  const showLink = showLinks();
  return (
    <Transition in={show} mountOnEnter unmountOnExit timeout={duration}>
      {status => (
        <Modal timeout={duration} onClose={close}>
          {({ containerProps }) => (
            <StyledDiv className={`${status}`} role='dialog' {...containerProps}>
              <StyledLink
                to='/products/renters-insurance/'
                showLink={showLink}
                onClick={onClose}
              >
                Products
              </StyledLink>
              <StyledLink
                to='/get-quote/'
                showLink={showLink}
                onClick={onClose}
              >
                Get a Quote
              </StyledLink>
              <StyledLink
                to='/enroll/customer-info/'
                showLink={!!emailAddress && showLink}
                onClick={onClose}
              >
                Enroll
              </StyledLink>
              <StyledSpan>Want to talk?</StyledSpan>
              <StyledPhoneButton
                  href='tel:18775770850'
                >
                <Phone color={WHITE}/>
                  1 (877) 577 0850
                </StyledPhoneButton>

              <StyledButton onClick={onClose}>
                <X size={18} />
              </StyledButton>
            </StyledDiv>
          )}
        </Modal>
      )}
    </Transition>
  )
}

MarketingNavModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
}

export default connect(({ savedQuote: { emailAddress } }) => ({
  emailAddress,
}))(MarketingNavModal)
